import React from "react";
import "./carousel_image.css";
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';



const Image = props => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  return (
    
    
    <React.Fragment>
      
      <div className="img-container">
      <Paper sx={{height:"45vh", width:"45vh"}}>
        <div className="loader-container">
      
      <CircularProgress color="primary" style={{height:"100px", width:"100px" ,visibility: isLoaded ? "hidden" : "visible" }} />
      </div>
     </Paper>

      
      <img
        onLoad={() => {
          setIsLoaded(true);
        }}
        className="image full"
        // eslint-disable-next-line 
        style={{ opacity: isLoaded ? 1 : 0 }, {objectFit:"cover"}}
        alt={props.alt}
        src={props.src}
      />
      </div>
    </React.Fragment>
  );
};
export default Image;